module.exports = __webpack_public_path__ + "static/media/Florentino Laime Mantilla.817b5b6d.jpg";